
import { supabase } from "@/integrations/supabase/client";

/**
 * Gets the public URL for a logo from the Supabase storage
 * @param name Name of the logo file in the logos bucket
 * @returns Public URL of the logo
 */
export const getLogoUrl = (name: string): string => {
  try {
    // Add file extension if not present
    const fileName = name.endsWith('.png') ? name : `${name}.png`;
    const { data } = supabase.storage.from('logos').getPublicUrl(fileName);
    
    console.log(`[LogoHelper] Getting URL for ${fileName}:`, data.publicUrl);
    return data.publicUrl;
  } catch (error) {
    console.error(`Error getting logo URL for ${name}:`, error);
    // Fallback to the local version if there's an error
    return `/lovable-uploads/${name}.png`;
  }
};

// Cache the URLs to avoid unnecessary calls
const logoCache: Record<string, string> = {};

/**
 * Gets and caches the logo URL for better performance
 * @param name Name of the logo file in the logos bucket
 * @returns Public URL of the logo
 */
export const getCachedLogoUrl = (name: string): string => {
  if (!logoCache[name]) {
    logoCache[name] = getLogoUrl(name);
  }
  return logoCache[name];
};

// Header and footer logo file names (without extension)
export const HEADER_LOGO_FILENAME = "fish-header";
export const FOOTER_LOGO_FILENAME = "fish-footer";
